import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { string } from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import i18next from "i18next";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import * as moment from "moment";
import { Image, Anchor } from "hesus-ui-kit";
import DatePicker from "react-multi-date-picker";
import ClipLoader from "react-spinners/ClipLoader";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import editIcon from "@icons/ic-edit-blue.svg";
import cancelIcon from "@icons/ic-edit-cancel.svg";
import saveIcon from "@icons/ic-yes-green.svg";
import { labelStyles, labelStylesError } from "@utils/extra-style";
import "../../DashboardView.scss";
import {
  DashboardContainerSection,
  GridRow,
  GridSubItem,
  GridSubLabel,
  CenterPagination,
} from "../../DashboardView.styled";

/**
 * Dashboard enquiries List,
 * Path - /
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3357016069/Widget+3+-+Sites+to+start+this+week)
 * @component
 */
const DashboardSiteList = (props) => {
  const { t, widgetName, widgetId, userId, countryId } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [siteData, setSiteData] = useState([]);
  // const [isEdit, setIsEdit] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageStart, setPageStart] = useState(0);
  const [editSiteId, setEditSiteId] = useState("");
  const [updateDate, setUpdateDate] = useState("");
  const [updateDateError, setUpdateDateError] = useState("");
  const currentDate = moment(new Date()).format("YYYY-MM-DD");

  const fetchSiteInfo = () => {
    setIsLoading(true);
    axios
      .get(
        `/dashboard/${userId}/widgets/${widgetId}?countryId=${countryId}&page=${currentPage}&limit=${pageSize}`
      )
      .then((response) => {
        setIsLoading(false);
        setSiteData(response.data[0]);
        setPageCount(response.data[0].totalRecords);
      })
      .catch((error) => {
        setPageCount(0);
      });
  };

  useEffect(() => {
    fetchSiteInfo();
  }, [currentPage]);

  useEffect(() => {
    if (isRefresh) {
      fetchSiteInfo();
      setIsRefresh(false);
    }
  }, [isRefresh]);

  const getDateColor = (startDate) => {
    let color = "#474747";
    if (startDate === currentDate) {
      color = "#ff981e";
    }
    return color;
  };

  const switchPage = (selectedPage) => {
    let pageStartLocal;
    if (selectedPage === 1) {
      pageStartLocal = 0;
    } else {
      pageStartLocal = pageSize * selectedPage - pageSize;
    }
    setCurrentPage(selectedPage);
    setPageStart(pageStartLocal);
  };

  const handleChangePage = (event, newPage) => {
    switchPage(newPage);
  };

  const editSiteDate = (siteId) => {
    setEditSiteId(siteId);
    setUpdateDate("");
    setUpdateDateError("");
  };
  const cancelSiteDate = () => {
    setEditSiteId("");
    setUpdateDate("");
    setUpdateDateError("");
  };

  const saveSiteDate = (siteId) => {
    setIsUpdating(true);
    if (updateDate) {
      axios
        .put(`/sites/${siteId}/updateStartDate`, {
          startDate: moment(updateDate).format("YYYY-MM-DD"),
        })
        .then(() => {
          setEditSiteId("");
          setUpdateDate("");
          setUpdateDateError("");
          setIsRefresh(true);
          setIsUpdating(false);
        })
        .catch((error) => {
          setUpdateDateError(error);
        });
    } else {
      setEditSiteId("");
      setUpdateDate("");
      setUpdateDateError("");
      setIsUpdating(false);
    }
  };
  const onStartDateChange = (e) => {
    if (e.toDate()) {
      setUpdateDate(moment(e.toDate()).format("YYYY-MM-DD"));
      setUpdateDateError("");
    }
  };

  return (
    <DashboardContainerSection className="dashboard-widget-view-site">
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}
      <GridRow
        borderBottom="2px solid #cccccc"
        padding="0px 0px 5px"
        marginBottom="7px"
      >
        <GridSubItem fontWeight="700" fontStyle="normal" fontSize="20px">
          {t(widgetName)}
        </GridSubItem>
      </GridRow>
      {!isLoading && siteData?.results?.length === 0 && (
        <GridRow marginBottom="10px" column="1fr" gap="1%">
          <GridSubItem
            fontStyle="normal"
            fontSize="16px"
            color="#474747"
            textAlign="center"
          >
            {t("NO_DATA")}
          </GridSubItem>
        </GridRow>
      )}
      {!isLoading && siteData?.results?.length > 0 && (
        <>
          <GridRow marginBottom="10px" column="58% 22% 18%" gap="1%">
            <GridSubItem fontStyle="normal" fontSize="14px" color="#474747">
              {t("WIDGET_SITE_CLIENT")}
            </GridSubItem>

            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {t("WIDGET_SITE_START_DATE")}
            </GridSubItem>
            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {" "}
            </GridSubItem>
          </GridRow>
          {siteData.results.map((request, requestIndex) => {
            return (
              <GridRow
                key={"dashboard-site-list-" + request.id + "-" + requestIndex}
                borderBottom={
                  requestIndex + 1 === siteData.results.length
                    ? "0px solid #cccccc"
                    : "1px solid #cccccc"
                }
                column="58% 22% 18%"
                gap="1%"
                padding="5px 0px"
              >
                <GridSubItem>
                  <GridRow>
                    <GridSubItem
                      fontWeight="700"
                      fontStyle="normal"
                      fontSize="16px"
                    >
                      <Anchor
                        className="dashboard-widget-view-site__link"
                        target="_blank"
                        url={`/site/view/${request.id}/general-info`}
                      >
                        {"#" + request.id}
                        {request.name ? " - " + request.name : ""}
                      </Anchor>
                    </GridSubItem>
                    <GridSubItem fontSize="14px" color="#474747">
                      {request.clientName}
                    </GridSubItem>
                  </GridRow>
                </GridSubItem>
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                  color={getDateColor(request.startDate)}
                >
                  {request.id !== editSiteId && request.startDate}
                  {request.id === editSiteId && (
                    <DatePicker
                      readonly
                      inputClass={
                        updateDateError
                          ? "dashboard-widget-view-site__date-input-error"
                          : "dashboard-widget-view-site__date-input"
                      }
                      containerClassName="dashboard-widget-view-site__datepicker-container"
                      type="text"
                      label={" "}
                      name="dashboard-widget-view-site-start-date"
                      id="dashboard-widget-view-site-start-date"
                      calendarPosition="bottom-center"
                      isFloat
                      onChange={onStartDateChange}
                      format={getDatePickerFormat()}
                      locale={getCalendarLocale()}
                      value={
                        getDateFormat(request.startDate, "YYYY-MM-DD") || ""
                      }
                      containerStyles={{ marginTop: "21px" }}
                      labelStyles={
                        updateDateError !== "" ? labelStylesError : labelStyles
                      }
                      required
                      error={updateDateError}
                      // placeholder={t("ESTIMATED_START_DATE")}
                    />
                  )}
                </GridSubLabel>
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                  color="#474747"
                >
                  {request.id !== editSiteId && (
                    <Image
                      title={t("WIDGET_SITE_EDIT_START_DATE")}
                      alt={t("WIDGET_SITE_EDIT_START_DATE")}
                      src={editIcon}
                      onClick={() => editSiteDate(request.id)}
                      className=".dashboard-widget-view-site__image_setting_icon"
                    />
                  )}
                  {!isUpdating && request.id === editSiteId && (
                    <>
                      <Image
                        src={saveIcon}
                        onClick={() => saveSiteDate(request.id)}
                        className=".dashboard-widget-view-site__image_setting_icon"
                      />
                      <Image
                        src={cancelIcon}
                        onClick={cancelSiteDate}
                        className=".dashboard-widget-view-site__image_setting_icon"
                      />
                    </>
                  )}
                  {isUpdating && request.id === editSiteId && (
                    <ClipLoader size={15} color="#00aeea" />
                  )}
                </GridSubLabel>
              </GridRow>
            );
          })}
        </>
      )}
      <GridRow>
        {!isLoading && siteData?.results?.length > 0 && (
          <CenterPagination>
            <Pagination
              count={Math.ceil(pageCount / pageSize)}
              showFirstButton
              showLastButton
              defaultPage={1}
              page={currentPage}
              onChange={handleChangePage}
            />
          </CenterPagination>
        )}
      </GridRow>
    </DashboardContainerSection>
  );
};

DashboardSiteList.propTypes = {
  t: PropTypes.func.isRequired,
  widgetName: PropTypes.string,
  widgetId: PropTypes.number,
  userId: PropTypes.number,
  countryId: PropTypes.number,
};

DashboardSiteList.defaultProps = {
  widgetName: null,
  widgetId: null,
  userId: null,
  countryId: null,
};

export default withTranslation()(DashboardSiteList);
